import getParameterFromURL from '../utils/scripts/getParameterFromURL';

const NUTRITION_ONBOARDING_CONFIGS = ['customV57', 'customV66'];
const PUPPY_ONBOARDING_CONFIGS = new Set(['customV45', 'customV51']);
const VET_ONBOARDING_CONFIGS = new Set(['customV55', 'customV60']);
const PUPPY_BLUES_ONBOARDING_CONFIGS = new Set(['customV56', 'customV63', 'customV67', 'customV68']);
const POTTY_ONBOARDING_CONFIGS = new Set(['customV69', 'customV70', 'customV71']);

const getConfigDerivedFlags = (config) => ({
  vetOnboarding: VET_ONBOARDING_CONFIGS.has(config),
  puppyBluesOnboarding: PUPPY_BLUES_ONBOARDING_CONFIGS.has(config),
});
const initialConfig = getParameterFromURL('config') || 'customV18';

const initialState = {
  currentStep: null,
  previousStep: 'age',
  nextStep: null,
  currentStepIndex: null,
  totalSteps: null,
  currentStepCompleted: null,
  showActionBar: null,

  separationStepIndexes: [],
  hideHeaderStepIndexes: [],
  hideProgressStepIndexes: [],
  progressTitlesBySection: [],

  showStartSurveyScreen: getParameterFromURL('startSurveyScreen') && true,
  withoutMail: true, // getParameterFromURL('withoutMail') || true,
  design: {
    startSurveyScreen: getParameterFromURL('startSurveyScreen'),
  },
  nutritionOnboarding: NUTRITION_ONBOARDING_CONFIGS.includes(initialConfig),
  config: initialConfig,
  puppyOnboarding: PUPPY_ONBOARDING_CONFIGS.has(initialConfig),
  puttyOnboarding: POTTY_ONBOARDING_CONFIGS.has(initialConfig),
  ...getConfigDerivedFlags(initialConfig),
  dogTranslator: initialConfig === 'customV59',
};

function steps(state = initialState, action) {
  switch (action.type) {
    case 'SET_STEPS':
      return {
        ...state,
        list: action.payload,
        puppyOnboarding: PUPPY_ONBOARDING_CONFIGS.has(state.config),
        puttyOnboarding: POTTY_ONBOARDING_CONFIGS.has(state.config),
        nutritionOnboarding: NUTRITION_ONBOARDING_CONFIGS.includes(state.config),
        ...getConfigDerivedFlags(state.config),
        dogTranslator: state.config === 'customV59',
      };

    case 'STEP_GO_TO':
      return {
        ...state,
        currentStep: action.payload,
      };

    case 'SET_TOTAL_STEPS':
      return {
        ...state,
        totalSteps: action.payload,
      };

    case 'SET_CURRENT_INDEX':
      return {
        ...state,
        currentStepIndex: action.payload,
      };

    case 'SET_STEP_STATUS':
      return {
        ...state,
        list: action.payload,
      };

    case 'SET_PREVIOUS_STEP':
      return {
        ...state,
        previousStep: action.payload,
      };

    case 'SET_NEXT_STEP':
      return {
        ...state,
        nextStep: action.payload,
      };

    case 'SET_CURRENT_STEP_COMPLETED_STATUS':
      return {
        ...state,
        currentStepCompleted: action.payload,
      };

    case 'CHECK_ACTION_BAR_SHOWING':
      return {
        ...state,
        showActionBar: action.payload,
      };

    case 'SET_CURRENT_CONFIG':
      return {
        ...state,
        currentConfig: action.payload,
      };

    case 'TOGGLE_START_SURVEY_SCREEN':
      return {
        ...state,
        showStartSurveyScreen: action.payload,
      };

    case 'SKIP_MAIL_PRESSED':
      return {
        ...state,
        skipMailPressed: action.payload,
      };

    case 'SET_STEPS_META':
      return {
        ...state,
        separationStepIndexes: action.payload.separationStepIndexes,
        hideHeaderStepIndexes: action.payload.hideHeaderStepIndexes,
        hideProgressStepIndexes: action.payload.hideProgressStepIndexes,
        progressTitlesBySection: action.payload.progressTitlesBySection,
      };

    case 'SET_PUPPY_ONBOARDING':
      return {
        ...state,
        puppyOnboarding: action.payload,
      };

    case 'SET_VET_ONBOARDING':
      return {
        ...state,
        vetOnboarding: action.payload,
      };

    case 'SET_NUTRITION_ONBOARDING':
      return {
        ...state,
        nutritionOnboarding: action.payload,
      };

    case 'SET_PUPPY_BLUES_ONBOARDING':
      return {
        ...state,
        puppyBluesOnboarding: action.payload,
      };

    default:
      return state;
  }
}

export default steps;
